import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import { selectApplyNowData, selectApplyNowStatus, selectApplyNowError, initializeAsync } from "./applyNowSlice";
import { CircularProgress, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { get } from "../../api";

// Add custom imports here

const ApplyNow = () => {
    const data = useSelector(selectApplyNowData);
    const status = useSelector(selectApplyNowStatus);
    const error = useSelector(selectApplyNowError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();

    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
            applyNow();
        }
    }, [status, dispatch]);

    const applyNow = async () => {
        const query = new URLSearchParams(window.location.search);
        const recordId = query.get("recordId");
        let result = await get(`applicant/getApplicants`, {
            emailId: encodeURIComponent(userDetails.username),
            listingId: recordId ? encodeURIComponent(recordId) : "",
            convertLead: "yes",
        });

        if (result.isSuccess && result.data && result.data.length > 0) {
            let activeApplication = result.data.find(
                (item) =>
                    item.application.status !== "Approved" &&
                    item.application.status !== "Canceled" &&
                    item.application.status !== "Declined"
            );
            if (activeApplication) {
                userDetails["applicant"] = activeApplication;
            } else {
                userDetails["applicant"] = result.data[0];
            }
            userDetails["applicants"] = result.data;
            userDetails["listingId"] = recordId;
            setUserDetailsNotAsync(userDetails);

            if (!activeApplication && userDetails?.applicants?.length > 0) {
                navigate("/multiple-application", {
                    replace: true,
                });
            } else {
                navigate("/", { replace: true });
            }
        }
    };

    let body = (
        <Container className="ApplicationMethod" sx={{ justifyContent: "center" }}>
            <CircularProgress
                color="success"
                sx={{ width: "60px !important", height: "60px !important" }}
                thickness="3.9"
            />
        </Container>
    );

    return getPageContent(body, status, error);
};

export { ApplyNow };
